import React from 'react';
import '../styles/Spinner.css';

const Spinner = ({ className } = {}) => {
    return <div className={"spinner" + (className ? " " + className : "")}></div>;
};

export default Spinner;